export const DL_BASELINE = {
  ev: 86.0,
  hardHitPct: 33,
  barrelPct: 6.5,
  sweetSpotPct: 33,
  maxEV: 103,
};
